/* This is a generated file, do not edit it directly */
import * as Types from '@noah-labs/shared-schema-gql';

import {
  useMutation,
  useQuery,
  useInfiniteQuery,
  UseMutationOptions,
  UseQueryOptions,
  UseInfiniteQueryOptions,
  InfiniteData,
} from '@tanstack/react-query';
import { useAppSyncRequest } from '@noah-labs/fe-shared-data-access-shared';
export type FrUserProfileFragment = {
  __typename?: 'UserProfile';
  UserID: string;
  Email: string;
  Groups?: Array<Types.UserGroup> | null;
  Username: string;
  UsernameDisplay: string;
  Referrals: number;
  AvatarUrl?: string | null;
  DisplayUnit: Types.CurrencyUnit;
  PrimaryCurrency: Types.CurrencyDisplayType;
  FiatCurrencyCode: Types.FiatCurrencyCode;
  FiatPaymentCurrencyCode?: Types.FiatCurrencyCode | null;
  LatestCountry?: Types.CountryCode | null;
  FeatureFlags?: Array<{
    __typename?: 'FeatureFlag';
    Feature: Types.Feature;
    Enabled: boolean;
    Reason?: Array<Types.FeatureFlagReason> | null;
    Currencies?: Array<Types.CurrencyCode> | null;
    Networks?: Array<Types.Network> | null;
  }> | null;
  PersonalName?: {
    __typename?: 'FullName';
    FirstName: string;
    MiddleName?: string | null;
    LastName: string;
  } | null;
  Metadata: { __typename?: 'UserMetadata'; GooglePlayStoreAppReviewed?: string | null };
  HomeAddress?: {
    __typename?: 'KycAddress';
    Street?: string | null;
    Street2?: string | null;
    City?: string | null;
    State?: string | null;
    PostCode?: string | null;
    CountryCode: Types.CountryCode;
  } | null;
  KycVerification: {
    __typename?: 'KycVerification';
    ApprovalStatus?: Types.KycApprovalStatus | null;
    ActionRequired?: Types.KycActionRequired | null;
    Expiry?: string | null;
  };
};

export type UserProfileCreateMutationVariables = Types.Exact<{
  Input: Types.UserProfileCreateInput;
}>;

export type UserProfileCreateMutation = {
  __typename?: 'Mutation';
  userProfileCreate: {
    __typename?: 'UserProfile';
    UserID: string;
    Email: string;
    Groups?: Array<Types.UserGroup> | null;
    Username: string;
    UsernameDisplay: string;
    Referrals: number;
    AvatarUrl?: string | null;
    DisplayUnit: Types.CurrencyUnit;
    PrimaryCurrency: Types.CurrencyDisplayType;
    FiatCurrencyCode: Types.FiatCurrencyCode;
    FiatPaymentCurrencyCode?: Types.FiatCurrencyCode | null;
    LatestCountry?: Types.CountryCode | null;
    FeatureFlags?: Array<{
      __typename?: 'FeatureFlag';
      Feature: Types.Feature;
      Enabled: boolean;
      Reason?: Array<Types.FeatureFlagReason> | null;
      Currencies?: Array<Types.CurrencyCode> | null;
      Networks?: Array<Types.Network> | null;
    }> | null;
    PersonalName?: {
      __typename?: 'FullName';
      FirstName: string;
      MiddleName?: string | null;
      LastName: string;
    } | null;
    Metadata: { __typename?: 'UserMetadata'; GooglePlayStoreAppReviewed?: string | null };
    HomeAddress?: {
      __typename?: 'KycAddress';
      Street?: string | null;
      Street2?: string | null;
      City?: string | null;
      State?: string | null;
      PostCode?: string | null;
      CountryCode: Types.CountryCode;
    } | null;
    KycVerification: {
      __typename?: 'KycVerification';
      ApprovalStatus?: Types.KycApprovalStatus | null;
      ActionRequired?: Types.KycActionRequired | null;
      Expiry?: string | null;
    };
  };
};

export type UserSettingsConsentCreateMutationVariables = Types.Exact<{
  Input: Types.UserSettingsConsentInput;
}>;

export type UserSettingsConsentCreateMutation = {
  __typename?: 'Mutation';
  userSettingsConsentCreate: {
    __typename?: 'UserSettingsConsent';
    EmailContact: boolean;
    Terms: boolean;
    Cookies?: {
      __typename?: 'CookieConsent';
      advertising?: boolean | null;
      marketingAndAnalytics?: boolean | null;
      functional: boolean;
    } | null;
  };
};

export type UpdateUserCurrencyUnitSettingMutationVariables = Types.Exact<{
  Input: Types.UserAppSettingsUpdateInput;
}>;

export type UpdateUserCurrencyUnitSettingMutation = {
  __typename?: 'Mutation';
  userAppSettingsUpdate: { __typename?: 'UserProfile'; DisplayUnit: Types.CurrencyUnit };
};

export type UpdateUserPrimaryCurrencySettingMutationVariables = Types.Exact<{
  Input: Types.UserAppSettingsUpdateInput;
}>;

export type UpdateUserPrimaryCurrencySettingMutation = {
  __typename?: 'Mutation';
  userAppSettingsUpdate: { __typename?: 'UserProfile'; PrimaryCurrency: Types.CurrencyDisplayType };
};

export type UpdateUserFiatCurrencyCodeSettingMutationVariables = Types.Exact<{
  Input: Types.UserAppSettingsUpdateInput;
}>;

export type UpdateUserFiatCurrencyCodeSettingMutation = {
  __typename?: 'Mutation';
  userAppSettingsUpdate: { __typename?: 'UserProfile'; FiatCurrencyCode: Types.FiatCurrencyCode };
};

export type UpdateUserFiatPaymentCurrencyCodeSettingMutationVariables = Types.Exact<{
  Input: Types.UserFiatPaymentCurrencyUpdate;
}>;

export type UpdateUserFiatPaymentCurrencyCodeSettingMutation = {
  __typename?: 'Mutation';
  userFiatPaymentCurrencyUpdate: {
    __typename?: 'UserProfile';
    FiatCurrencyCode: Types.FiatCurrencyCode;
    FiatPaymentCurrencyCode?: Types.FiatCurrencyCode | null;
  };
};

export type UpdateFullNameMutationVariables = Types.Exact<{
  Input: Types.UserAppSettingsUpdateInput;
}>;

export type UpdateFullNameMutation = {
  __typename?: 'Mutation';
  userAppSettingsUpdate: {
    __typename?: 'UserProfile';
    PersonalName?: {
      __typename?: 'FullName';
      FirstName: string;
      MiddleName?: string | null;
      LastName: string;
    } | null;
  };
};

export type UpdateGooglePlayStoreAppReviewedMetadataMutationVariables = Types.Exact<{
  Input: Types.UserMetadataUpdateInput;
}>;

export type UpdateGooglePlayStoreAppReviewedMetadataMutation = {
  __typename?: 'Mutation';
  userMetadataUpdate: {
    __typename?: 'UserProfile';
    Metadata: { __typename?: 'UserMetadata'; GooglePlayStoreAppReviewed?: string | null };
  };
};

export type UpdateUserLimitsMutationVariables = Types.Exact<{
  Input: Types.UserLimitUpdateInput;
}>;

export type UpdateUserLimitsMutation = {
  __typename?: 'Mutation';
  updateUserLimits: {
    __typename?: 'UserLimitUpdateResponse';
    limits: Array<{
      __typename?: 'UserLimit';
      Period: Types.PolicyPeriod;
      Signature: string;
      LimitType: Types.UserLimitType;
      FiatAmount?: {
        __typename?: 'FiatAmount';
        Amount: string;
        FiatCurrency: Types.FiatCurrencyCode;
      } | null;
    }>;
  };
};

export type UserInitQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserInitQuery = {
  __typename?: 'Query';
  userSettingsConsent: Array<{
    __typename?: 'UserSettingsConsent';
    EmailContact: boolean;
    Terms: boolean;
    Cookies?: {
      __typename?: 'CookieConsent';
      advertising?: boolean | null;
      marketingAndAnalytics?: boolean | null;
      functional: boolean;
    } | null;
  } | null>;
  userProfile: {
    __typename?: 'UserProfile';
    UserID: string;
    Email: string;
    Groups?: Array<Types.UserGroup> | null;
    Username: string;
    UsernameDisplay: string;
    Referrals: number;
    AvatarUrl?: string | null;
    DisplayUnit: Types.CurrencyUnit;
    PrimaryCurrency: Types.CurrencyDisplayType;
    FiatCurrencyCode: Types.FiatCurrencyCode;
    FiatPaymentCurrencyCode?: Types.FiatCurrencyCode | null;
    LatestCountry?: Types.CountryCode | null;
    FeatureFlags?: Array<{
      __typename?: 'FeatureFlag';
      Feature: Types.Feature;
      Enabled: boolean;
      Reason?: Array<Types.FeatureFlagReason> | null;
      Currencies?: Array<Types.CurrencyCode> | null;
      Networks?: Array<Types.Network> | null;
    }> | null;
    PersonalName?: {
      __typename?: 'FullName';
      FirstName: string;
      MiddleName?: string | null;
      LastName: string;
    } | null;
    Metadata: { __typename?: 'UserMetadata'; GooglePlayStoreAppReviewed?: string | null };
    HomeAddress?: {
      __typename?: 'KycAddress';
      Street?: string | null;
      Street2?: string | null;
      City?: string | null;
      State?: string | null;
      PostCode?: string | null;
      CountryCode: Types.CountryCode;
    } | null;
    KycVerification: {
      __typename?: 'KycVerification';
      ApprovalStatus?: Types.KycApprovalStatus | null;
      ActionRequired?: Types.KycActionRequired | null;
      Expiry?: string | null;
    };
  };
};

export type UserLimitsQueryVariables = Types.Exact<{
  currencyCodes?: Types.Maybe<Array<Types.CurrencyCode>>;
}>;

export type UserLimitsQuery = {
  __typename?: 'Query';
  userLimit: {
    __typename?: 'UserLimitResponse';
    Limits: Array<{
      __typename?: 'OrderLimitPolicy';
      Customer: boolean;
      BusinessCustomer: boolean;
      IndividualCustomer: boolean;
      OrderType: Types.OrderType;
      Period: Types.PolicyPeriod;
      Network?: Types.Network | null;
      VolumeLimit: {
        __typename?: 'VolumeLimit';
        Limit?: {
          __typename?: 'FiatAmount';
          Amount: string;
          FiatCurrency: Types.FiatCurrencyCode;
          CryptoAmounts?: Array<{
            __typename?: 'CryptoAmount';
            Amount: string;
            Currency: Types.CurrencyCode;
            Price?: string | null;
            FetchedAt?: string | null;
          }> | null;
        } | null;
        Usage?: {
          __typename?: 'FiatAmount';
          Amount: string;
          FiatCurrency: Types.FiatCurrencyCode;
          CryptoAmounts?: Array<{
            __typename?: 'CryptoAmount';
            Amount: string;
            Currency: Types.CurrencyCode;
            Price?: string | null;
            FetchedAt?: string | null;
          }> | null;
        } | null;
        Minimum?: {
          __typename?: 'FiatAmount';
          Amount: string;
          FiatCurrency: Types.FiatCurrencyCode;
          CryptoAmounts?: Array<{
            __typename?: 'CryptoAmount';
            Amount: string;
            Currency: Types.CurrencyCode;
            Price?: string | null;
            FetchedAt?: string | null;
          }> | null;
        } | null;
        Signing?: {
          __typename?: 'FiatAmount';
          Amount: string;
          FiatCurrency: Types.FiatCurrencyCode;
          CryptoAmounts?: Array<{
            __typename?: 'CryptoAmount';
            Amount: string;
            Currency: Types.CurrencyCode;
            Price?: string | null;
            FetchedAt?: string | null;
          }> | null;
        } | null;
      };
    }>;
  };
};

export const FrUserProfileFragmentDoc = /*#__PURE__*/ `
    fragment FrUserProfile on UserProfile {
  UserID
  Email
  Groups
  Username
  UsernameDisplay
  Referrals
  AvatarUrl
  FeatureFlags {
    Feature
    Enabled
    Reason
    Currencies
    Networks
  }
  DisplayUnit
  PrimaryCurrency
  FiatCurrencyCode
  FiatPaymentCurrencyCode
  PersonalName {
    FirstName
    MiddleName
    LastName
  }
  Metadata {
    GooglePlayStoreAppReviewed
  }
  HomeAddress {
    Street
    Street2
    City
    State
    PostCode
    CountryCode
  }
  LatestCountry
  KycVerification {
    ApprovalStatus
    ActionRequired
    Expiry
  }
}
    `;
export const UserProfileCreateDocument = /*#__PURE__*/ `
    mutation UserProfileCreate($Input: UserProfileCreateInput!) {
  userProfileCreate(Input: $Input) {
    ...FrUserProfile
  }
}
    ${FrUserProfileFragmentDoc}`;

export const useUserProfileCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UserProfileCreateMutation,
    TError,
    UserProfileCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UserProfileCreateMutation,
    TError,
    UserProfileCreateMutationVariables,
    TContext
  >({
    mutationKey: ['UserProfileCreate'],
    mutationFn: useAppSyncRequest<UserProfileCreateMutation, UserProfileCreateMutationVariables>(
      UserProfileCreateDocument,
    ),
    ...options,
  });
};

export const UserSettingsConsentCreateDocument = /*#__PURE__*/ `
    mutation UserSettingsConsentCreate($Input: UserSettingsConsentInput!) {
  userSettingsConsentCreate(Input: $Input) {
    Cookies {
      advertising
      marketingAndAnalytics
      functional
    }
    EmailContact
    Terms
  }
}
    `;

export const useUserSettingsConsentCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UserSettingsConsentCreateMutation,
    TError,
    UserSettingsConsentCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UserSettingsConsentCreateMutation,
    TError,
    UserSettingsConsentCreateMutationVariables,
    TContext
  >({
    mutationKey: ['UserSettingsConsentCreate'],
    mutationFn: useAppSyncRequest<
      UserSettingsConsentCreateMutation,
      UserSettingsConsentCreateMutationVariables
    >(UserSettingsConsentCreateDocument),
    ...options,
  });
};

export const UpdateUserCurrencyUnitSettingDocument = /*#__PURE__*/ `
    mutation UpdateUserCurrencyUnitSetting($Input: UserAppSettingsUpdateInput!) {
  userAppSettingsUpdate(Input: $Input) {
    DisplayUnit
  }
}
    `;

export const useUpdateUserCurrencyUnitSettingMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserCurrencyUnitSettingMutation,
    TError,
    UpdateUserCurrencyUnitSettingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserCurrencyUnitSettingMutation,
    TError,
    UpdateUserCurrencyUnitSettingMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateUserCurrencyUnitSetting'],
    mutationFn: useAppSyncRequest<
      UpdateUserCurrencyUnitSettingMutation,
      UpdateUserCurrencyUnitSettingMutationVariables
    >(UpdateUserCurrencyUnitSettingDocument),
    ...options,
  });
};

export const UpdateUserPrimaryCurrencySettingDocument = /*#__PURE__*/ `
    mutation UpdateUserPrimaryCurrencySetting($Input: UserAppSettingsUpdateInput!) {
  userAppSettingsUpdate(Input: $Input) {
    PrimaryCurrency
  }
}
    `;

export const useUpdateUserPrimaryCurrencySettingMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserPrimaryCurrencySettingMutation,
    TError,
    UpdateUserPrimaryCurrencySettingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserPrimaryCurrencySettingMutation,
    TError,
    UpdateUserPrimaryCurrencySettingMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateUserPrimaryCurrencySetting'],
    mutationFn: useAppSyncRequest<
      UpdateUserPrimaryCurrencySettingMutation,
      UpdateUserPrimaryCurrencySettingMutationVariables
    >(UpdateUserPrimaryCurrencySettingDocument),
    ...options,
  });
};

export const UpdateUserFiatCurrencyCodeSettingDocument = /*#__PURE__*/ `
    mutation UpdateUserFiatCurrencyCodeSetting($Input: UserAppSettingsUpdateInput!) {
  userAppSettingsUpdate(Input: $Input) {
    FiatCurrencyCode
  }
}
    `;

export const useUpdateUserFiatCurrencyCodeSettingMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserFiatCurrencyCodeSettingMutation,
    TError,
    UpdateUserFiatCurrencyCodeSettingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserFiatCurrencyCodeSettingMutation,
    TError,
    UpdateUserFiatCurrencyCodeSettingMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateUserFiatCurrencyCodeSetting'],
    mutationFn: useAppSyncRequest<
      UpdateUserFiatCurrencyCodeSettingMutation,
      UpdateUserFiatCurrencyCodeSettingMutationVariables
    >(UpdateUserFiatCurrencyCodeSettingDocument),
    ...options,
  });
};

export const UpdateUserFiatPaymentCurrencyCodeSettingDocument = /*#__PURE__*/ `
    mutation UpdateUserFiatPaymentCurrencyCodeSetting($Input: UserFiatPaymentCurrencyUpdate!) {
  userFiatPaymentCurrencyUpdate(Input: $Input) {
    FiatCurrencyCode
    FiatPaymentCurrencyCode
  }
}
    `;

export const useUpdateUserFiatPaymentCurrencyCodeSettingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateUserFiatPaymentCurrencyCodeSettingMutation,
    TError,
    UpdateUserFiatPaymentCurrencyCodeSettingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserFiatPaymentCurrencyCodeSettingMutation,
    TError,
    UpdateUserFiatPaymentCurrencyCodeSettingMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateUserFiatPaymentCurrencyCodeSetting'],
    mutationFn: useAppSyncRequest<
      UpdateUserFiatPaymentCurrencyCodeSettingMutation,
      UpdateUserFiatPaymentCurrencyCodeSettingMutationVariables
    >(UpdateUserFiatPaymentCurrencyCodeSettingDocument),
    ...options,
  });
};

export const UpdateFullNameDocument = /*#__PURE__*/ `
    mutation UpdateFullName($Input: UserAppSettingsUpdateInput!) {
  userAppSettingsUpdate(Input: $Input) {
    PersonalName {
      FirstName
      MiddleName
      LastName
    }
  }
}
    `;

export const useUpdateFullNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateFullNameMutation,
    TError,
    UpdateFullNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<UpdateFullNameMutation, TError, UpdateFullNameMutationVariables, TContext>({
    mutationKey: ['UpdateFullName'],
    mutationFn: useAppSyncRequest<UpdateFullNameMutation, UpdateFullNameMutationVariables>(
      UpdateFullNameDocument,
    ),
    ...options,
  });
};

export const UpdateGooglePlayStoreAppReviewedMetadataDocument = /*#__PURE__*/ `
    mutation UpdateGooglePlayStoreAppReviewedMetadata($Input: UserMetadataUpdateInput!) {
  userMetadataUpdate(Input: $Input) {
    Metadata {
      GooglePlayStoreAppReviewed
    }
  }
}
    `;

export const useUpdateGooglePlayStoreAppReviewedMetadataMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateGooglePlayStoreAppReviewedMetadataMutation,
    TError,
    UpdateGooglePlayStoreAppReviewedMetadataMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateGooglePlayStoreAppReviewedMetadataMutation,
    TError,
    UpdateGooglePlayStoreAppReviewedMetadataMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateGooglePlayStoreAppReviewedMetadata'],
    mutationFn: useAppSyncRequest<
      UpdateGooglePlayStoreAppReviewedMetadataMutation,
      UpdateGooglePlayStoreAppReviewedMetadataMutationVariables
    >(UpdateGooglePlayStoreAppReviewedMetadataDocument),
    ...options,
  });
};

export const UpdateUserLimitsDocument = /*#__PURE__*/ `
    mutation UpdateUserLimits($Input: UserLimitUpdateInput!) {
  updateUserLimits(Input: $Input) {
    limits {
      Period
      Signature
      FiatAmount {
        Amount
        FiatCurrency
      }
      LimitType
    }
  }
}
    `;

export const useUpdateUserLimitsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserLimitsMutation,
    TError,
    UpdateUserLimitsMutationVariables,
    TContext
  >,
) => {
  return useMutation<UpdateUserLimitsMutation, TError, UpdateUserLimitsMutationVariables, TContext>(
    {
      mutationKey: ['UpdateUserLimits'],
      mutationFn: useAppSyncRequest<UpdateUserLimitsMutation, UpdateUserLimitsMutationVariables>(
        UpdateUserLimitsDocument,
      ),
      ...options,
    },
  );
};

export const UserInitDocument = /*#__PURE__*/ `
    query UserInit {
  userSettingsConsent {
    Cookies {
      advertising
      marketingAndAnalytics
      functional
    }
    EmailContact
    Terms
  }
  userProfile {
    ...FrUserProfile
  }
}
    ${FrUserProfileFragmentDoc}`;

export const useUserInitQuery = <TData = UserInitQuery, TError = unknown>(
  variables?: UserInitQueryVariables,
  options?: Omit<UseQueryOptions<UserInitQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UserInitQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<UserInitQuery, TError, TData>({
    queryKey: variables === undefined ? ['UserInit'] : ['UserInit', variables],
    queryFn: useAppSyncRequest<UserInitQuery, UserInitQueryVariables>(UserInitDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useUserInitQuery.getKey = (variables?: UserInitQueryVariables) =>
  variables === undefined ? ['UserInit'] : ['UserInit', variables];

export const useInfiniteUserInitQuery = <TData = InfiniteData<UserInitQuery>, TError = unknown>(
  variables: UserInitQueryVariables,
  options: Omit<UseInfiniteQueryOptions<UserInitQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<UserInitQuery, TError, TData>['queryKey'];
  },
) => {
  const query = useAppSyncRequest<UserInitQuery, UserInitQueryVariables>(UserInitDocument);
  return useInfiniteQuery<UserInitQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['UserInit.infinite']
            : ['UserInit.infinite', variables],
        queryFn: (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteUserInitQuery.getKey = (variables?: UserInitQueryVariables) =>
  variables === undefined ? ['UserInit.infinite'] : ['UserInit.infinite', variables];

export const UserLimitsDocument = /*#__PURE__*/ `
    query UserLimits($currencyCodes: [CurrencyCode!]) {
  userLimit {
    Limits {
      Customer
      BusinessCustomer
      IndividualCustomer
      OrderType
      Period
      Network
      VolumeLimit {
        Limit {
          Amount
          CryptoAmounts(CurrencyCodes: $currencyCodes) {
            Amount
            Currency
            Price
            FetchedAt
          }
          FiatCurrency
        }
        Usage {
          Amount
          CryptoAmounts(CurrencyCodes: $currencyCodes) {
            Amount
            Currency
            Price
            FetchedAt
          }
          FiatCurrency
        }
        Minimum {
          Amount
          CryptoAmounts(CurrencyCodes: $currencyCodes) {
            Amount
            Currency
            Price
            FetchedAt
          }
          FiatCurrency
        }
        Signing {
          Amount
          CryptoAmounts(CurrencyCodes: $currencyCodes) {
            Amount
            Currency
            Price
            FetchedAt
          }
          FiatCurrency
        }
      }
    }
  }
}
    `;

export const useUserLimitsQuery = <TData = UserLimitsQuery, TError = unknown>(
  variables?: UserLimitsQueryVariables,
  options?: Omit<UseQueryOptions<UserLimitsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<UserLimitsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<UserLimitsQuery, TError, TData>({
    queryKey: variables === undefined ? ['UserLimits'] : ['UserLimits', variables],
    queryFn: useAppSyncRequest<UserLimitsQuery, UserLimitsQueryVariables>(UserLimitsDocument).bind(
      null,
      variables,
    ),
    ...options,
  });
};

useUserLimitsQuery.getKey = (variables?: UserLimitsQueryVariables) =>
  variables === undefined ? ['UserLimits'] : ['UserLimits', variables];

export const useInfiniteUserLimitsQuery = <TData = InfiniteData<UserLimitsQuery>, TError = unknown>(
  variables: UserLimitsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<UserLimitsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseInfiniteQueryOptions<UserLimitsQuery, TError, TData>['queryKey'];
  },
) => {
  const query = useAppSyncRequest<UserLimitsQuery, UserLimitsQueryVariables>(UserLimitsDocument);
  return useInfiniteQuery<UserLimitsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options;
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ['UserLimits.infinite']
            : ['UserLimits.infinite', variables],
        queryFn: (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
        ...restOptions,
      };
    })(),
  );
};

useInfiniteUserLimitsQuery.getKey = (variables?: UserLimitsQueryVariables) =>
  variables === undefined ? ['UserLimits.infinite'] : ['UserLimits.infinite', variables];
